import { fromJS } from 'immutable';

export default fromJS({
    achUploadAvailability: {
        isAchUploadAvailable: true,
        errorMessage: null
    },
});